"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grantRoleFieldsValidation = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const types_1 = require("@framework/types");
exports.grantRoleFieldsValidation = (0, yup_1.object)().shape({
    role: (0, yup_1.mixed)()
        .oneOf(Object.values(types_1.AccessControlRoleType))
        .required("form.validations.valueMissing"),
    address: yup_rules_eth_1.addressValidationSchema,
});
//# sourceMappingURL=validation.js.map